module.exports = __webpack_public_path__ + "img/sex-offender.svg";